
import axios from "axios";
import {apiUrl} from '../AxiosAPI' ;  

  
// Create Folder API post call with rest endpoint 
export const createNewMockTest= (apiData) => axios.post(`${apiUrl}/createNewMockTest`,apiData);  
export const getQuizDataByQuizId= (apiData) => axios.post(`${apiUrl}/getQuizDataByQuizId`,apiData);  
export const createNewMockSection= (apiData) => axios.post(`${apiUrl}/createNewMockSection`,apiData);  
export const getSectionsByQuizId= (apiData) => axios.post(`${apiUrl}/getSectionsByQuizId`,apiData);  
 export const createNewQuestion= (apiData) => axios.post(`${apiUrl}/createNewQuestion`,apiData);  
export const getQuestionsByQuizId= (apiData) => axios.post(`${apiUrl}/getQuestionsByQuizId`,apiData);  
 
export const createNewQuestionsOption= (apiData) => axios.post(`${apiUrl}/createNewQuestionsOption`,apiData);  
export const getOptionsByQuestionId= (apiData) => axios.post(`${apiUrl}/getOptionsByQuestionId`,apiData);  
export const getAllQuizSectionsQuestionsOptionsInOne= (apiData) => axios.post(`${apiUrl}/getAllQuizSectionsQuestionsOptionsInOne`,apiData);  
 
